module.exports = __webpack_public_path__ + "img/ni.4023068b.svg";